// extracted by mini-css-extract-plugin
export var calendarView = "_fw-0";